module.exports = __webpack_public_path__ + "static/logo-728eed44e68530eee5a62f382dc1c07c.png";